<template>
    <div>
        <v-card height="100%">
            <v-card color="primary" @click="cardExpand = !cardExpand">
                <v-card-title class="card-title-text">{{ cardTitle }}</v-card-title>
            </v-card>
            <v-expand-transition>
                <v-container class="pt-5 px-4 pb-0" v-if="cardExpand">
                    <v-row>
                        <v-col cols="12" :md="extraInfoColumSize" class="checks-margin" v-for="(item, index) in extraDataInfo"
                               :key="index">
                            <span class="text-subtitle">
                                {{ item.label }}
                            </span>
                            <p class="label-text2" v-if="item.editEstado == 0">
                                <v-icon size="15" class="mr-1" v-if="item.dato != '' && item.notEditable != true && cerrado == 0
                  " v-on:click="checkEditCampo(index)">
                                    mdi-pencil
                                </v-icon>
                                {{ item.dato == "" ? "" : item.dato }}
                            </p>

                            <div v-if="item.editEstado == 1">
                                <v-text-field class="mx-1" label="" solo dense v-model="editTextFieldValue" :rules="rules" v-on:blur="
                  editTextFieldValue =
                  editTextFieldValue != null
                    ? editTextFieldValue.trim()
                    : null
                  "></v-text-field>
                                <v-row>
                                    <v-spacer></v-spacer>
                                    <v-icon v-on:click="editCampoSave(extraDataInfo[index], index)">
                                        mdi-content-save
                                    </v-icon>
                                    <span> </span>
                                    <v-icon v-on:click="
                    (extraDataInfo[index].editEstado = 0),
                    (editingCampo = false)
                    " class="mr-4">
                                        mdi-cancel
                                    </v-icon>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="12">
                            <div class="buttons-for-checks my-3" v-for="(item, index) in checkBoxesInfo" :key="index">
                                <!-- TODO: define if its yes/now checkboxes -->
                                <div v-if="item.visible == true && item.claveMovimiento == 721">
                                    <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
                    ? 'yesButton-style'
                    : 'yesButton-unselected-style'
                    ">
                                        <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                                    </v-btn>
                                    <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 0)" outlined :class="item.respuestaNO == 'true'
                    ? 'noButton-style'
                    : 'noButton-unselected-style'
                    ">
                                        <v-icon size="14" color="white" v-if="item.respuestaNO == 'true'">mdi-check</v-icon>
                                    </v-btn>

                                    <v-btn v-if="item.tipoRespuesta == 1" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
                    ? 'yesButton-style'
                    : 'yesButton-unselected-style'
                    ">
                                        <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                                    </v-btn>
                                    <span class="movimiento-style-text"> {{ item.nombre }}</span>
                                    <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta1.length > 0">
                                        {{ item.etiqueta1 }}
                                    </v-chip>
                                    <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta2 != 0">
                                        {{ item.etiqueta2 }}
                                    </v-chip>
                                    <v-chip class="mx-1 tags-margin" color="#ff4569" label dark small v-if="item.etiqueta3.length > 0">
                                        <v-icon left small v-if="item.editable == 1" v-on:click="showEditSwal(item, index)">
                                            mdi-pencil
                                        </v-icon>
                                        {{ item.etiqueta3 }}
                                    </v-chip>
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12"
                               :md="checkBoxesColumSize"
                               v-for="(items, index) in subTitlesData"
                               :key="index"
                               v-if="items != 'Inicial'">
                            <h1 class="text-center checkbox-title-text">{{ items }}</h1>
                            <div class="buttons-for-checks my-3" v-for="(item, index) in checkBoxesInfo" :key="index">
                                <!-- TODO: define if its yes/now checkboxes -->
                                <div v-if="item.visible == true && item.Tipo == items">
                                    <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
                      ? 'yesButton-style'
                      : 'yesButton-unselected-style'
                      ">
                                        <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                                    </v-btn>
                                    <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 0)" outlined :class="item.respuestaNO == 'true'
                      ? 'noButton-style'
                      : 'noButton-unselected-style'
                      ">
                                        <v-icon size="14" color="white" v-if="item.respuestaNO == 'true'">mdi-check</v-icon>
                                    </v-btn>

                                    <v-btn v-if="item.tipoRespuesta == 1" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
                      ? 'yesButton-style'
                      : 'yesButton-unselected-style'
                      ">
                                        <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                                    </v-btn>
                                    <span class="movimiento-style-text">
                                        {{ item.nombre }}
                                    </span>
                                    <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta1.length > 0">
                                        {{ item.etiqueta1 }}
                                    </v-chip>
                                    <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta2 != 0">
                                        ${{ item.etiqueta2 }}
                                    </v-chip>
                                    <v-chip class="mx-1 tags-margin" color="#ff4569" label dark small v-if="item.etiqueta3.length > 0">
                                        <v-icon left small v-if="item.editable == 1" v-on:click="showEditSwal(item, index)">
                                            mdi-pencil
                                        </v-icon>
                                        ${{ item.etiqueta3 }}
                                    </v-chip>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <div>
                            <br />
                        </div>
                    </v-row>
                </v-container>

            </v-expand-transition>
        </v-card>
        

    </div>
</template>

<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";

export default {
  props: [
    "cardTitle",
    "subTitlesData",
    "checkBoxesInfo",
    "extraDataInfo",
    "fatherColumSize",
    "showDisposicion",
    "valueDisposicion",
  ],
  data() {
      return {
          cardExpand: true,
      extraInfoColumSize: 6,
      checkBoxesColumSize: 12,
      editTextFieldValue: [],
      cerrado: 1,
      editingCampo: false,
      showj: false,
      rules: [
        (v) => !!v || "Campo requerido",
        (v) => {
          if (v == null) {
            return true;
          } else {
            if (v.trim().length < 6) {
              return "Mínimo 6 Carácteres";
            } else if (v.trim().length > 60) {
              return "Máximo 60 Carácteres";
            } else return true;
          }
        },
      ],
      datos: [],
    };
  },
  methods: {
    async showEditSwal(item, index) {
      this.$swal({
        position: "center",
        title: "Cargando...",
        html: "Espere un momento por favor",
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirm: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      let entryTypeResponse = await reporteExpJur.reporteObtenerEditCampoInfo(
        this.datos,
        item.ieapid
      );

      if (entryTypeResponse[0].validEntry == 1) {
        if (entryTypeResponse[0].ieaptipo == "select") {
          var selectItems = await JSON.parse(entryTypeResponse[0].selectItems);

          var options = {};
          selectItems.forEach((element) => {
            options[element.id] = element.text;
          });

          this.$swal.close();
          this.$swal({
            title: "Edita el dato del movimiento",
            input: "select",
            inputOptions: options,
            inputAttributes: {
              style: "background-color: #d1d1e0 !important;",
            },
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Editar",
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !this.$swal.isLoading(),
          }).then(async (result) => {
            if (result.isConfirmed) {
              let editResponse = await reporteExpJur.reporteEditCampoInfo(
                this.datos,
                item.ieapid,
                result.value
              );

              if (editResponse[0].EditSuccess == 1) {
                this.checkBoxesInfo[index].etiqueta3 = options[result.value];
                this.$swal({
                  position: "center",
                  icon: "success",
                  title: "Exito!",
                  html: "El campo se editó correctamente",
                  showConfirmButton: false,
                  timer: 5000,
                }).then(() => {
                  window.location.reload();
                });

                return;
              }
              this.$swal({
                position: "center",
                icon: "error",
                title: "Error al editar el campo",
                html: "Error al editar el campo, intente de nuevo, si el problema persiste, contacte a soporte",
                showConfirmButton: false,
                timer: 5000,
              });
            }
          });
          return;
        }
        this.$swal({
          position: "center",
          icon: "error",
          title: "Opss... algo salió mal",
          html: "Error al obtener el tipo de entrada, intente de nuevo, si el problema persiste, contacte a soporte",
          showConfirmButton: false,
          timer: 5000,
        });
      }
    },
    checkEditCampo(index) {
      this.showj = false;
      this.showj = true;

      //setTimeout(() => {
      //    this.showj = true;

      //}, 0);
      if (this.editingCampo) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "No puede editar otro campo mientras uno este en edición",
          showConfirmButton: true,
          timer: 2000,
        });
        return;
      } else {
        this.editTextFieldValue = this.extraDataInfo[index].dato.toString();
        this.extraDataInfo[index].editEstado = 1;
        this.editingCampo = true;
      }
    },
    resizeColums() {
      if (this.subTitlesData.length > 0) {
        if (this.subTitlesData.length > 3) {
          this.checkBoxesColumSize = 4;
        } else {
          this.checkBoxesColumSize = 12 / this.subTitlesData.length;
        }
      }

      if (this.fatherColumSize > 6) {
        this.extraInfoColumSize = 6;
      } else {
        this.extraInfoColumSize = 12;
      }
    },
    async editCampoSave(item, index) {
      let newText = this.editTextFieldValue.toString();
      let oldText = item.dato;
      newText = newText.trim();

      if (newText == oldText) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "Debe cambiar al menos un dato",
          showConfirmButton: true,
          timer: 5000,
        });
        return;
      }
      if (newText.length < 6 || newText.length > 60) {
        return;
      }

      //LOADING DIALOG
      this.$swal({
        position: "center",
        title: "Cargando...",
        html: "Espere un momento por favor",
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirm: false,
      });

      this.$swal.showLoading();

      if (newText == "" || newText == null || newText == undefined) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "El campo no puede estar vacío",
          showConfirmButton: false,
          timer: 5000,
        });
        this.editingCampo = false;
        this.editTextFieldValue = null;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
        return;
      }

      // PROCESO DE EDICION
      const editCampoResponse = await reporteExpJur.editCampo(
        this.datos,
        item.tabla,
        item.campo,
        newText
      );

      this.editTextFieldValue = "";
      if (editCampoResponse) {
        this.$swal({
          position: "center",
          icon: "success",
          title: "Campo editado correctamente",
          showConfirmButton: true,
          timer: 5000,
        });
        this.editingCampo = false;
        this.extraDataInfo[index].dato = newText;
        this.extraDataInfo[index].editEstado = 0;
      } else {
        this.$swal({
          position: "center",
          icon: "error",
          title: "Error al editar el campo",
          showConfirmButton: true,
          timer: 5000,
        });
        this.editingCampo = false;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
      }
    },

    async movimientoTryPush(item, respuesta) {
      //SI EL MOVIMIENTO YA TIENE UNA RESPUESTA EN SI, NO HACER NADA
      if (this.cerrado == 1) {
        return;
      }
      if (item.respuestaSI == "true") {
        return;
      }
      if (item.respuestaNO == "true" && respuesta == 0) {
        return;
      }

      //TODO: HACER AQUI UN LOADING EN LO QUE SE VERIFICA LA INFO:
      this.$swal({
        position: "center",
        title: "Verificando, espere un momento....",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      let validMovimientoResponse = await reporteExpJur.validaNuevoMovimiento(
        this.datos,
        item.claveMovimiento,
        respuesta
      );

      try {
        let result = validMovimientoResponse[0];

        if (result.puedeInsertar == 1) {
          var toToken = {
            claveMovimiento: item.claveMovimiento,
            respuesta: respuesta,
          };
          let token = MetodosGenerales.generateJsonToken(toToken);
          this.$swal.close();
          this.$router.push({
            name: `AgregarMovimientoRLV`,
            params: {
              tokenData: token,
            },
          });
        } else {
          let errorMessage =
            "Antes de insertar este movimiento necesita:" +
            "<br /> " +
            "<b> " +
            result.concepto +
            "</b>";
          this.$swal.close();
          this.$swal({
            position: "center",
            icon: "error",
            title: "Movimiento Faltante",
            html: errorMessage,
            showConfirmButton: true,
          });
        }
      } catch (e) {
        this.$swal.close();
        this.$swal({
          position: "center",
          icon: "error",
          title: "Opss... algo salio mal",
          html: "Error al verificar el movimiento, intente de nuevo, si el problema persiste contacte a soporte",
          showConfirmButton: true,
        });
      }
    },
  },
  beforeMount() {
    this.resizeColums();
  },
  async created() {
    this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    await reporteExpJur.obtenervalConclusion(this, this.datos);

    setTimeout(() => {
      this.showj = true;
    }, 1000);
  },
};
</script>
@import
url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;800&display=swap');

<style scoped>
.collapsable-container {
  background-color: white;
  height: 100% !important;
}

.title-card-style {
  padding: 1.5px !important;
  max-height: auto;
}

.text-subtitle {
  font-family: "Poppins", sans-serif;
  font-size: 0.9em;
}

.card-title-text {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1em;
  color: white;
}

.label-text {
  font-family: "Roboto", sans-serif;
  font-weight: 700 !important;
  font-size: 12px !important;
}

.label-text2 {
  font-family: "Roboto", sans-serif;
  font-weight: 700 !important;
  font-size: 16px !important;
}

.checkbox-title-text {
  font-family: "Roboto", sans-serif;
  font-weight: 800 !important;
  font-size: 16px !important;
  color: #adb9ff;
}

.buttons-for-checks {
  margin-bottom: 3px !important;
}

.movimiento-style-text {
  font-family: "Roboto", sans-serif;
  font-weight: 600 !important;
  font-size: 14px !important;
}

.checkbox-section-subtitle {
  font-family: "Roboto", sans-serif;
  font-weight: 800 !important;
  font-size: 14px !important;
  color: #004919;
}

    .noButton-style {
        width: 25px !important;
        height: 25px !important;
        min-width: 25px !important;
        min-height: 25px !important;
        padding: 0 !important;
        margin-right: 5px;
        background-color: #f44336 !important;
        color: #f44336 !important;
    }

    .noButton-unselected-style {
        width: 25px !important;
        height: 25px !important;
        min-width: 25px !important;
        min-height: 25px !important;
        padding: 0 !important;
        margin-right: 5px;
        color: red !important;
    }

    .yesButton-style {
        width: 25px !important;
        height: 25px !important;
        min-width: 25px !important;
        min-height: 25px !important;
        padding: 0 !important;
        margin-right: 5px;
        background-color: #4caf !important;
        color: #4caf !important;
        /* #4caf */
    }

    .yesButton-unselected-style {
        width: 25px !important;
        height: 25px !important;
        min-width: 25px !important;
        min-height: 25px !important;
        padding: 0 !important;
        margin-right: 5px;
        color: #4caf !important;
    }

.tags-margin {
  margin-top: 2px !important;
  margin-bottom: 5px !important;
}
</style>
